module.exports = __webpack_public_path__ + "static/media/anniu4_hui.9064f5de.png";